/**
 * Reusable impact section component for drag-drop modal
 * Displays the impact of a file/folder move operation
 */

import React from 'react';
import { Box, Typography } from '@mui/joy';
import { ScenarioConfig } from '../../types/dragDropScenarios';
import { useTranslation } from 'react-i18next';

interface ImpactSectionProps {
  config: ScenarioConfig;
}

/**
 * Component to render the impact section with title and items
 * Extracted for reusability and easier testing
 */
export const ImpactSection: React.FC<ImpactSectionProps> = ({ config }) => {
  const { t } = useTranslation();
  return (
    <Box className="impact-section">
      <Typography
        level="body-sm"
        sx={{ fontWeight: 700, color: config.titleColor, marginBottom: '6px' }}
      >
        <span role="img" aria-label={t('icon')}>
          {config.icon}
        </span>{' '}
        {config.title}
      </Typography>
      <Box className="impact-items">
        {config.impactItems.map((item, index) => (
          <Typography key={index} level="body-sm" className="impact-item">
            • {item.text}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default ImpactSection;
